import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";

/** Monospace stack for fenced code; prose uses Tajawal in mdwriter.css */
export const MARKDOWN_PREVIEW_FONT_FAMILY =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace';

/** Align with `--vh-assessment-*` / mdwriter preview */
export const MARKDOWN_PREVIEW_CODE_BG = "#f0f7f6";
export const MARKDOWN_PREVIEW_CODE_FG = "#07393c";

const PRE_KEY = 'pre[class*="language-"]';
const CODE_KEY = 'code[class*="language-"]';
const INLINE_CODE_KEY = ':not(pre) > code[class*="language-"]';

/**
 * Prism `oneLight` adds translucent fills on tokens — strip those and
 * use the document font; keep a solid pane background on `pre` only.
 */
export function buildPreviewPrismStyle(base) {
  const out = {};

  for (const [key, raw] of Object.entries(base)) {
    if (!raw || typeof raw !== "object") {
      out[key] = raw;
      continue;
    }

    const style = { ...raw };
    const isSelection =
      key.includes("::selection") || key.includes("::-moz-selection");
    const isPre = key === PRE_KEY;
    const isCodeRoot = key === CODE_KEY;
    const isInlineCode = key === INLINE_CODE_KEY;

    if (isSelection) {
      style.background = "hsl(230, 1%, 88%)";
      if ("backgroundColor" in style) delete style.backgroundColor;
    } else if (isPre) {
      style.background = MARKDOWN_PREVIEW_CODE_BG;
      style.backgroundColor = MARKDOWN_PREVIEW_CODE_BG;
      style.color = MARKDOWN_PREVIEW_CODE_FG;
      style.fontFamily = MARKDOWN_PREVIEW_FONT_FAMILY;
      style.margin = "0";
      style.padding = "0";
    } else if (isCodeRoot || isInlineCode) {
      style.background = "transparent";
      style.backgroundColor = "transparent";
      style.color = MARKDOWN_PREVIEW_CODE_FG;
      style.fontFamily = MARKDOWN_PREVIEW_FONT_FAMILY;
    } else {
      style.background = "transparent";
      style.backgroundColor = "transparent";
    }

    out[key] = style;
  }

  return out;
}

export const previewPrismStyle = buildPreviewPrismStyle(oneLight);
